import { useEffect, useState, useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { PropertyFilter as PropertyFilterComponent } from 'customer-data-filters-ui/public/components';
import { useBuildJourneyFilterStrategy } from './useBuildJourneyFilterStrategy';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const draftFilterExists = maybeDraftFilter => Boolean(maybeDraftFilter && maybeDraftFilter.operation);
function ObjectPropertiesFilter({
  properties,
  objectTypeId,
  onApply,
  currentValue,
  onCancel
}) {
  const [draftFilter, setDraftFilter] = useState();
  useEffect(() => {
    setDraftFilter(currentValue);
  }, [currentValue]);
  const strategy = useBuildJourneyFilterStrategy({
    properties,
    dataType: objectTypeId
  });
  const handlePropertyFilterChange = useCallback(filter => {
    if (filter) {
      setDraftFilter(filter);
    }
  }, [setDraftFilter]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PropertyFilterComponent, {
      filterFamily: objectTypeId,
      hidePropertySelect: false,
      onChange: handlePropertyFilterChange,
      strategy: strategy,
      use: "vertical",
      value: currentValue
    }), /*#__PURE__*/_jsxs(ButtonWrapper, {
      paddingBlockStart: "200",
      children: [/*#__PURE__*/_jsx(Button, {
        use: "tertiary",
        onClick: () => {
          if (draftFilter) {
            onApply(draftFilterExists(draftFilter) ? draftFilter : undefined);
          }
        },
        disabled: !draftFilter,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-enablement.reportEditors.journeyPropertyFilter.apply"
        })
      }), /*#__PURE__*/_jsx(Button, {
        use: "tertiary-light",
        onClick: onCancel,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-enablement.reportEditors.journeyPropertyFilter.cancel"
        })
      })]
    })]
  });
}
export default ObjectPropertiesFilter;